


import Vue from 'vue';
import {RouteName} from "@/router";
import i18n, {localizedRoute} from "@/i18n/i18n.config";
import {Location} from "vue-router";
import {OfferItem, TranslatedString} from "@/components/model/offer-item";

export default Vue.extend({
    props: {
        path: String as () => RouteName,
        showPrices: {
            type: Boolean,
            default: true
        },
        withDivider: {
            type: Boolean,
            default: false
        },
        items: Array as () => OfferItem[],
        isLoading: Boolean
    },
    data: () => ({
        skeletonLoadingCount: 4
    }),
    methods: {
        detailsRouteFor(item: OfferItem): Location {
            return localizedRoute(this.path, {itemName: item.urlFriendlyName, itemId: '' + item.id});
        },
        getLocalizedString(value: TranslatedString): string {
            return i18n.locale === 'pl' ? value.pl : value.en;
        }
    }
});
